import React from "react";
import PropTypes from "prop-types";
import VoucherTitle from "@components/VoucherManager/VoucherTitle";
import "./style.scss";

const VoucherSummaryItems = ({ selectedItems, totalPrice }) => (
    <div className="voucher-summary-items__wrapper">
        <h2 className="voucher-summary-items__title">Purchase Summary</h2>
        {selectedItems?.map((item) => {
            const unitPrice = totalPrice > 0 ? item.price_cents : item.display_price_cents;

            return (
                <div className="voucher-summary-items__item" key={item.key}>
                    <span className="voucher-summary-items__quantity">{item.quantity} x</span>
                    <VoucherTitle
                        consumableDescription={item.short_description}
                        additionalClasses="voucher-summary-items__name"
                    />
                    <span className="voucher-summary-items__price">
                        ${(unitPrice / 100).toFixed(2)}
                    </span>
                </div>
            );
        })}
    </div>
);

VoucherSummaryItems.propTypes = {
    selectedItems: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            quantity: PropTypes.number.isRequired,
            price_cents: PropTypes.number.isRequired,
            rrp_price_cents: PropTypes.number,
        })
    ),
    totalPrice: PropTypes.number.isRequired,
};

export default VoucherSummaryItems;
